/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Attach_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to update the agent for this chat." |
*
* @param {Agent_Builder_Attach_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_attach_error = /** @type {((inputs?: Agent_Builder_Attach_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Attach_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Agent für diesen Chat konnte nicht aktualisiert werden.")
	return /** @type {LocalizedString} */ ("Failed to update the agent for this chat.")
});